import { from, merge, Observable, of } from 'rxjs';
import { map, mergeMap, retry, switchMap } from 'rxjs/operators';

import { authorizedFetch, readJson } from './http.js';
import { extractRelevantInformation } from './internet_research.js';

export function parallelPaperResearch(messages, queries, question) {
    let visitedIds = new Set();
    return merge(...queries.map(fetchPaperResearch)).pipe(
        mergeMap(papers => new Observable(observer => {
            for (let p of papers) {
                if (visitedIds.has(p.id)) {
                    continue;
                }
                visitedIds.add(p.id);
                observer.next(p);
            }
            observer.complete();
        })),
        mergeMap(paper => extractRelevantInformation(paper.content, [question], 0).pipe(
            map(extract => ({
                ...paper,
                extract,
            })),
        )),
    );
}

function fetchPaperResearch(query) {
    return of(undefined).pipe(
        switchMap(() => from(authorizedFetch(`/api/paper-research?q=${encodeURIComponent(query)}`))),
        readJson(),
        retry({
            count: 3,
            delay: 1000 + 500*Math.random(),
        }),
    );
}
